/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskZoomInfoOrgChart
 */
export interface ExecRiskZoomInfoOrgChart {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    contact_id: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    department: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    job_function: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    org_chart_tier: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    org_chart_sub_tier: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    has_email: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskZoomInfoOrgChart
     */
    accuracy?: number;
}

/**
 * Check if a given object implements the ExecRiskZoomInfoOrgChart interface.
 */
export function instanceOfExecRiskZoomInfoOrgChart(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contact_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "department" in value;
    isInstance = isInstance && "job_function" in value;
    isInstance = isInstance && "org_chart_tier" in value;
    isInstance = isInstance && "org_chart_sub_tier" in value;
    isInstance = isInstance && "has_email" in value;

    return isInstance;
}

export function ExecRiskZoomInfoOrgChartFromJSON(json: any): ExecRiskZoomInfoOrgChart {
    return ExecRiskZoomInfoOrgChartFromJSONTyped(json, false);
}

export function ExecRiskZoomInfoOrgChartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskZoomInfoOrgChart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contact_id': json['contact_id'],
        'name': json['name'],
        'title': json['title'],
        'department': json['department'],
        'job_function': json['job_function'],
        'org_chart_tier': json['org_chart_tier'],
        'org_chart_sub_tier': json['org_chart_sub_tier'],
        'has_email': json['has_email'],
        'accuracy': !exists(json, 'accuracy') ? undefined : json['accuracy'],
    };
}

export function ExecRiskZoomInfoOrgChartToJSON(value?: ExecRiskZoomInfoOrgChart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contact_id': value.contact_id,
        'name': value.name,
        'title': value.title,
        'department': value.department,
        'job_function': value.job_function,
        'org_chart_tier': value.org_chart_tier,
        'org_chart_sub_tier': value.org_chart_sub_tier,
        'has_email': value.has_email,
        'accuracy': value.accuracy,
    };
}

